import { DefaultHomecard } from '@spotahome/ui-library';

export default DefaultHomecard;
